import React from 'react'
import PropTypes from 'prop-types'
import WithLabel from '../WithLabel'
import Select from '../Select'

/**
 * The [Select](#Select) component with a label.
 */
const LabeledSelect = ({ children, ...domProps }) => (
  <WithLabel {...domProps}>{({ ...props }) => <Select {...props}>{children}</Select>}</WithLabel>
)

LabeledSelect.defaultProps = {
  color: 'light',
}

LabeledSelect.propTypes = {
  children: PropTypes.node,
}

export default LabeledSelect
